import http from "../../http";

const vHeader = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded"
  }
};

const postLogin = (dispatch, credentials, actionType) => {
  var httpParams = JSON.stringify({
    usuario: credentials.user,
    password: credentials.password
  });

  dispatch({ type: "LOGIN_LOADING" });

  http
    .post("login.php", httpParams, vHeader)
    .then(function(response) {
      const data = response.data;
      dispatch({
        type: actionType + "_SUCCESS",
        payload: {
          accessToken: data.token,
          userId: data.idUsuario,
          user: credentials.user,
          userFullName: data.nombreUsuario,
          sucursal: data.sucursal,
          nombresucursal: data.nombresucursal,
          puesto: data.puesto,
          puestoDescripcion: data.puestoDescripcion,
          foto: data.foto
        }
      });
    })
    .catch(function(error) {
      let errorMessage = "";
      if (error.response) {
        errorMessage = error.response.data.mensaje;
      } else if (error.request) {
        errorMessage = "The request was made but no response was received";
      } else {
        errorMessage = error.message;
      }
      dispatch({
        type: actionType + "_ERROR",
        payload: { error: errorMessage }
      });
    })
    .finally(function() {
    });
};

export const cambiarsucursal = (idsucursal, nombresucursal) => {
  return (dispatch, getState) => {
    dispatch({
      type: "CAMBIO_SUCURSAL",
      payload: {
        sucursal: idsucursal,
        nombresucursal: nombresucursal
      }
    });
  };
};

export const login = credentials => {
  return (dispatch, getState) => {
    postLogin(dispatch, credentials, "LOGIN");
  };
};

export const logout = () => {
  return (dispatch, getState) => {
    dispatch({ type: "LOGOUT_SUCCESS" });
  };
};

export const lock = () => {
  return (dispatch, getState) => {
    dispatch({ type: "LOCK_SUCCESS" });
  };
};

export const unlock = credentials => {
  return (dispatch, getstate) => {
    postLogin(dispatch, credentials, "UNLOCK");
  };
};
